import { render, staticRenderFns } from "./Compromise.vue?vue&type=template&id=dead46ec&"
import script from "./Compromise.vue?vue&type=script&lang=js&"
export * from "./Compromise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports